import { jsx } from "react/jsx-runtime";
import React from "react";
var checkmark_box_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3v18h18V3H3zm2 16V5h14v14H5zM16.551 7.5048l-5.9727 6.0047-3.1593-3.1763-1.418 1.4104 4.5773 4.6019 7.3907-7.4303-1.418-1.4104z" })];
};
export {
  checkmark_box_default as default
};
